export const CONTAINER = "container";
export const ICONS = "icons";
export const TEXT = "text";
export const TRACK = "track";
export const LOCATION = "race-location";
export const FLAG = "flag";
